import { Component, inject } from "@angular/core";
import { NgGlyph } from "@ng-icons/core";
import { ToastItem } from "./Dto/ToastModel";
import { ToastEffects } from "./State/ToastEffects";
import { ToastState } from "./State/ToastState";

@Component({
  selector: "app-toast-container",
  standalone: true,
  imports: [NgGlyph],
  templateUrl: "./ToastContainerComponent.html",
  styleUrl: "./ToastContainerComponent.scss",
})
export class ToastContainerComponent {
  private readonly toastState = inject(ToastState);
  private readonly toastEffects = inject(ToastEffects);

  readonly toasts = this.toastState.data;

  getIcon(variant: ToastItem["variant"]): string {
    switch (variant) {
      case "success":
        return "check_circle";
      case "error":
        return "error";
      case "warning":
        return "warning";
      case "info":
      default:
        return "info";
    }
  }

  dismiss(id: string): void {
    this.toastEffects.dismiss(id);
  }
}
